function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M10.688 5.414a1.313 1.313 0 102.625 0 1.313 1.313 0 00-2.626 0zm0 6.563a1.312 1.312 0 102.624 0 1.312 1.312 0 00-2.624 0zm0 6.562a1.312 1.312 0 102.624 0 1.312 1.312 0 00-2.624 0z"
})));